const tippy = require("./tippy.min.js")
const module = angular.module('ryTooltip', []);

module.directive('ryTooltip', function($parse) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            let instance;

            const init = function() {
                const expr = $parse(attrs['ryTooltip'] || {});
                const param = expr(scope);
                
                let content = "";
                let placement = "bottom";

                if (typeof attrs['ryTooltipPlacement'] === 'string') {
                    placement = attrs.ryTooltipPlacement;
                }

                if (typeof param === 'object' && param !== null) {
                    placement = param.placement || 'bottom';
                    content = param.content || '';
                } else if (typeof param === 'string' || typeof param === 'number') {
                    content = param;
                }

                if (instance) {
                    instance.destroy();
                }

                if (param !== null) {
                    instance = tippy(element[0], {
                        content,
                        placement
                    });
                }
            }

            init();

            scope.$watch(attrs.ryTooltip, function(newVal, oldVal) {
                if (newVal !== oldVal) {
                    init();
                }
            });

            element.on('$destroy', function() {
                if (instance) instance.destroy();
            });
        }
    }
})